import * as Plyr from 'plyr';

const ROOT_SELECTOR = '.about-page__purposes-video-root';
const INIT_FLAG = 'stcPlyrInit';

const PLYR_OPTIONS: Plyr.Options = {
  controls: [
    'play-large',
    'play',
    'progress',
    'current-time',
    'duration',
    'mute',
    'volume',
    'fullscreen',
  ],
  hideControls: true,
  resetOnEnd: false,
  keyboard: { focused: true, global: false },
  tooltips: { controls: true, seek: true },
  i18n: {
    restart: 'С начала',
    rewind: 'Назад на {seektime} с',
    play: 'Воспроизвести',
    pause: 'Пауза',
    fastForward: 'Вперёд на {seektime} с',
    seek: 'Перейти',
    seekLabel: '{currentTime} из {duration}',
    played: 'Просмотрено',
    buffered: 'Буфер',
    currentTime: 'Текущее время',
    duration: 'Длительность',
    volume: 'Громкость',
    mute: 'Без звука',
    unmute: 'Со звуком',
    enterFullscreen: 'Полный экран',
    exitFullscreen: 'Выйти из полноэкранного режима',
    frameTitle: 'Проигрыватель',
  },
};

export function initAboutPurposesPlyr(scope: ParentNode = document): void {
  const root = scope.querySelector<HTMLElement>(ROOT_SELECTOR);
  if (!root || root.dataset[INIT_FLAG] === '1') {
    return;
  }

  const video = root.querySelector<HTMLVideoElement>('video');
  if (!video) return;

  new Plyr.default(video, PLYR_OPTIONS);
  root.dataset[INIT_FLAG] = '1';
  initPurposesVideoRootReveal(root);
}

const REVEAL_VISIBLE_CLASS = 'about-page__purposes-video-root--visible';

function initPurposesVideoRootReveal(root: HTMLElement): void {
  const motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  if (!motionOk) {
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        root.classList.add(REVEAL_VISIBLE_CLASS);
        obs.unobserve(root);
      });
    },
    { threshold: 0.5 },
  );

  observer.observe(root);
}
